import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import VideoTable from "./videoTable"

const VideoList = ({ user_type }) => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Videos"} breadcrumbItem={"Videos"} />
          <VideoTable user_type={user_type} />
        </Container>
      </div>
    </>
  )
}

export default VideoList
